<div class="d2">
  @if (
    paymentMethod &&
    !paymentMethod?.hasPaymentMethod &&
    currentRestaurant?.status == 'activated' &&
    !isFreePlan
  ) {
    <div class="sub-alert-banner sub-alert-banner--info">
      <span class="sub-alert-icon"><i class="bx bx-info-circle"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Your payment method is not configured</div>
        <div class="sub-alert-desc">
          Add a payment method to keep your subscription and add-ons active.
        </div>
      </div>
    </div>
  }
  @if (isCancellationScheduled && currentRestaurant?.status == 'activated') {
    <div class="sub-alert-banner sub-alert-banner--warning">
      <span class="sub-alert-icon"><i class="bx bx-calendar-x"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Your subscription is set to cancel</div>
        <div class="sub-alert-desc">
          You'll keep access until
          {{ convertSecondsToUTCTime(subscriptionDetails?.currentPeriodEnd) }}. Manage billing to
          keep your subscription active.
        </div>
      </div>
    </div>
  }
  @if (isPastDue && currentRestaurant?.status == 'activated') {
    <div class="sub-alert-banner sub-alert-banner--danger">
      <span class="sub-alert-icon"><i class="bx bx-error-circle"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Your last payment failed</div>
        <div class="sub-alert-desc">
          Update your payment method to keep your subscription and add-ons active.
        </div>
      </div>
    </div>
  }
  @if (isFreePlan && currentRestaurant?.status == 'activated') {
    <div class="sub-alert-banner sub-alert-banner--upgrade">
      <span class="sub-alert-icon"><i class="bx bx-rocket"></i></span>
      <div class="sub-alert-text">
        @if (
          hasActivePromotion &&
          subscriptionDetails?.activePromotion?.eligibilityStrategy == 'SIGNUP_BEFORE_DATE'
        ) {
          <div class="sub-alert-title">
            Upgrade free with {{ subscriptionDetails?.activePromotionName || 'our current promo' }}
          </div>
          <div class="sub-alert-desc">
            Switch to Standard or Premium before
            {{ convertSecondsToUTCDate(subscriptionDetails?.promoEndsAt) }} at no extra cost —
            billing only starts automatically after that.
          </div>
        } @else {
          <div class="sub-alert-title">You're on the Free plan</div>
          <div class="sub-alert-desc">
            Upgrade to Standard or Premium to unlock more features for your restaurant.
          </div>
        }
      </div>
      <a class="d2-btn-primary sub-alert-banner-action" routerLink="/main/billing-and-subscription"
        >Go to Subscription</a
      >
    </div>
  }
  @if (hasNoPosProvider) {
    <div class="sub-alert-banner sub-alert-banner--warning">
      <span class="sub-alert-icon"><i class="bx bx-store-alt"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Select a POS provider to start taking orders</div>
        <div class="sub-alert-desc">
          Choose Fork &amp; Find, or connect Square, Clover or Swirepay. Dine-in, online and to-go
          ordering stay off until you do.
        </div>
      </div>
      @if (canOpenHardware) {
        <a class="d2-btn-primary sub-alert-banner-action" routerLink="/main/hardware"
          >Select POS Provider</a
        >
      } @else {
        <button
          type="button"
          class="d2-btn-primary sub-alert-banner-action"
          [disabled]="enablingFnf"
          (click)="onEnableForkAndFind()"
        >
          {{ enablingFnf ? 'Enabling…' : 'Enable Fork & Find' }}
        </button>
      }
    </div>
  }
  <!-- Greeting: full width (Figma) -->
  <header class="d2-greet">
    <h1 class="d2-greet-title d2-greet-animate-in">{{ greetingTitle }}</h1>
    <p
      class="d2-greet-sub"
      [class.d2-greet-animate-in]="quoteAnimated"
      [class.d2-greet-sub--shimmer]="quoteAnimated"
    >
      {{ todayQuote }}
    </p>
  </header>

  <div class="d-flex pt-1 pb-1 justify-content-between align-items-baseline">
    <div class="d-flex gap-3">
      <div class="d2-sub-icon pl-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <!--Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free-->
          <path
            d="M19 2c-1.65 0-3 1.35-3 3 0 1 .49 1.87 1.24 2.42l-1.92 4.61c-.11-.01-.21-.03-.32-.03-.46 0-.89.11-1.29.3l-2.02-2.02c.19-.39.3-.82.3-1.29 0-1.65-1.35-3-3-3s-3 1.35-3 3c0 .82.33 1.57.87 2.11l-2.04 4.91c-1.57.09-2.83 1.39-2.83 2.98s1.35 3 3 3 3-1.35 3-3c0-1-.49-1.87-1.24-2.42l1.92-4.61c.11.01.21.03.32.03.46 0 .89-.11 1.29-.3l2.02 2.02c-.19.39-.3.82-.3 1.29 0 1.65 1.35 3 3 3s3-1.35 3-3c0-.82-.33-1.57-.87-2.11l2.04-4.91C20.74 7.89 22 6.59 22 5s-1.35-3-3-3M5 20c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M8 9c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m7 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m4-10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
          ></path>
        </svg>
      </div>
      <div class="d2-sub-title">Stat Overview</div>
    </div>
    <button type="button" class="d2-period-btn">
      <div class="dropdown">
        <button
          class="btn dropdown-toggle rounded-5 border"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ displayStatPeriod }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          @for (period of statPeriods; track period; let i = $index) {
            <li (click)="onChangeStatPeriod(period)">
              <a class="dropdown-item">{{ period.title }}</a>
            </li>
          }
        </ul>
      </div>
    </button>
  </div>

  <!-- Top stats (full width) -->
  <section class="d2-section d2-stats">
    <div class="d2-stats-head">
      <div class="d2-period d-none">
        <span class="d2-muted">Stats overview for:</span>
        <button type="button" class="d2-period-btn">
          <div class="dropdown ml-3 pt-2">
            <button
              class="btn dropdown-toggle border-bottom rounded-1"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ displayStatPeriod }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              @for (period of statPeriods; track period; let i = $index) {
                <li (click)="onChangeStatPeriod(period)">
                  <a class="dropdown-item">{{ period.title }}</a>
                </li>
              }
            </ul>
          </div>
        </button>
      </div>
      <!-- <a class="d2-link-detail" href="/main/report">View detailed stats</a> -->
    </div>
    <div class="d2-compact-stats d-none">
      @for (card of compactStats; track $index) {
        <article class="d2-compact-card">
          <div class="d2-compact-copy">
            <p class="d2-compact-title">{{ card.title }}</p>
            <p class="d2-compact-value">{{ card.value }}</p>
          </div>
          <!-- <div class="d2-compact-icon" aria-hidden="true">
            <i [class]="card.icon"></i>
          </div> -->
          <div class="d2-insight-icon" [attr.data-tone]="card.tone">
            <i [class]="card.icon"></i>
          </div>
        </article>
      }
    </div>
    <div class="d2-stat-cards">
      @if (statsLoading) {
        @for (placeholder of skeletonMiniCards; track $index) {
          <article class="d2-mini-card">
            <div class="d2-mini-card-top">
              <div class="skeleton-shimmer skeleton-line w-60"></div>
              <div class="skeleton-shimmer skeleton-line w-25"></div>
            </div>
            <div class="d2-mini-body">
              <div class="skeleton-shimmer d2-mini-thumb"></div>
              <div class="skeleton-shimmer skeleton-line w-80"></div>
            </div>
          </article>
        }
      } @else {
        @for (s of statCards; track s.category) {
          <article class="d2-mini-card">
            <div class="d2-mini-card-top">
              <span class="d2-mini-label">{{ s.category }}</span>
              <span
                class="d2-mini-sales"
                [class.d2-sales--ok]="s.salesTone === 'success'"
                [class.d2-sales--bad]="s.salesTone === 'danger'"
              >
                {{ s.salesText }}
              </span>
            </div>
            <div class="d2-mini-body">
              @if (isThumbMissing(s)) {
                <span class="d2-mini-thumb d2-mini-thumb--icon" aria-hidden="true">
                  <mat-icon svgIcon="dish-icon"></mat-icon>
                </span>
              } @else {
                <img
                  [src]="s.imageUrl"
                  [alt]="s.itemName"
                  class="d2-mini-thumb"
                  width="44"
                  height="44"
                  (error)="onImageError(s)"
                />
              }
              <span class="d2-mini-name">{{ s.itemName }}</span>
            </div>
          </article>
        }
      }
      @for (s of statCards; track s.category) {
        <article class="d2-mini-card d-none">
          <div
            class="d-flex flex-column align-items-center gap-3 p-3"
            [style.border]="s.borderColor"
          >
            <span class="d2-mini-label">{{ s.category }}</span>
            @if (isThumbMissing(s)) {
              <span class="d2-mini-thumb d2-mini-thumb--icon" aria-hidden="true">
                <mat-icon svgIcon="dish-icon"></mat-icon>
              </span>
            } @else {
              <img
                [src]="s.imageUrl"
                [alt]="s.itemName"
                class="d2-mini-thumb"
                width="50"
                height="50"
                (error)="onImageError(s)"
              />
            }
            <span class="d2-mini-name-sub">{{ s.itemName }}</span>
            <span
              class="d2-mini-sales"
              [class.d2-sales--ok]="s.salesTone === 'success'"
              [class.d2-sales--bad]="s.salesTone === 'danger'"
            >
              {{ s.salesText }}
            </span>
          </div>
          <!-- <div class="d2-mini-body">
            
          </div> -->
        </article>
      }
    </div>
  </section>
  <section class="d2-compact-stats">
    @if (statsLoading) {
      @for (placeholder of skeletonCompactCards; track $index) {
        <article class="d2-compact-card">
          <div class="d2-compact-copy">
            <div class="skeleton-shimmer skeleton-line w-60"></div>
            <div class="skeleton-shimmer skeleton-line skeleton-line-value"></div>
          </div>
          <div class="skeleton-shimmer d2-compact-icon"></div>
        </article>
      }
    } @else {
      @for (card of compactStats; track $index) {
        <article class="d2-compact-card">
          <div class="d2-compact-copy">
            <p class="d2-compact-title">{{ card.title }}</p>
            <p class="d2-compact-value">{{ card.value }}</p>
          </div>
          <!-- <div class="d2-compact-icon" aria-hidden="true">
            <i [class]="card.icon"></i>
          </div> -->
          <div class="d2-insight-icon" [attr.data-tone]="card.tone">
            @if (card.svgIcon) {
              <mat-icon [svgIcon]="card.svgIcon" aria-hidden="true"></mat-icon>
            } @else {
              <i [class]="card.icon"></i>
            }
          </div>
        </article>
      }
    }
  </section>

  <div class="d-flex pt-1 pb-3 gap-3">
    <div class="d2-sub-icon pl-3">
      <i class="bx bx-brain font-weight-bold"></i>
    </div>
    <div class="d2-sub-title">AI INSIGHTS</div>
  </div>

  <!-- Insights | AI (same row) -->
  <div class="d2-row d2-row--split pt-2">
    <div class="d2-split-left">
      <section class="d2-card d2-insights">
        <div
          class="d2-insight-row-header d-flex justify-content-between pl-4 pr-4 pt-3 pb-2 align-items-baseline border-bottom"
        >
          <p class="d2-insight-row-header-desc">
            Get insights on restaurant's performance and growth opportunities.
          </p>
          <span class="badge badge-pill pl-3 pr-3 insight-count"
            >{{ allInsightsHaveValue ? insights.length : 0 }} Insights</span
          >
        </div>
        @if (insightsLoading) {
          <p class="d2-insights-loading">Loading insights…</p>
        } @else if (insights.length > 0 && allInsightsHaveValue) {
          <div class="d2-insight-slide-viewport" [@insightSlide]="insightSlideIndex">
            @for (row of visibleInsights; track row.insightID; let i = $index) {
              <div class="d2-insight-row">
                <div class="d2-insight-icon" data-tone="grey">
                  <img src="assets/AI.svg" alt="" width="50%" height="50%" />
                </div>
                <div class="d2-insight-copy">
                  <p class="d2-insight-title">{{ row.insight }}</p>
                  <p
                    class="d2-insight-desc"
                    [matTooltip]="row.insightValue"
                    matTooltipPosition="below"
                    matTooltipClass="d2-insight-tooltip"
                  >
                    {{ row.insightValue }}
                  </p>
                </div>
                <button
                  type="button"
                  class="d2-btn-chat"
                  (click)="onChatInsight(i + insightSlideIndex * insightsPerSlide)"
                >
                  <i class="bx bx-message-rounded-dots d2-btn-chat-text"></i>
                  <span class="d2-btn-chat-text">Chat</span>
                </button>
              </div>
            }
          </div>
          @if (insightSlidePages.length > 1) {
            <div class="d2-dots d2-insight-dots" role="tablist" aria-label="Insight slides">
              @for (page of insightSlidePages; track page; let i = $index) {
                <button
                  type="button"
                  class="d2-dot"
                  [class.d2-dot--on]="insightSlideIndex === i"
                  (click)="setInsightSlide(i)"
                  [attr.aria-label]="'Insight slide ' + (i + 1)"
                ></button>
              }
            </div>
          }
        } @else {
          <div class="d2-insights-empty" role="status">
            <div class="d2-insights-empty-icon" aria-hidden="true">
              <img src="assets/AI.svg" alt="" />
            </div>
            <p class="d2-insights-empty-title">No AI Insights</p>
            <p class="d2-insights-empty-desc">
              You have no AI insights at the moment. They'll appear here once generated.
            </p>
          </div>
        }
      </section>
    </div>
    <div class="d2-split-right">
      <section class="d2-card d2-ai pb-5">
        <div class="d2-ai-inner">
          <div class="d2-ai-art" aria-hidden="true">
            <!-- <img src="assets/growth_icon.png" alt="AI Art" width="100%" height="100%" /> -->
          </div>
          <div class="d2-ai-copy">
            <p class="d2-ai-lead">
              Unlock growth insights for <strong>{{ restaurantName }}</strong> by chatting with our
              AI!
            </p>
            <ul class="d2-ai-bullets">
              <li>Get menu suggestions and smart recommendations to boost sales</li>
              <li>Get suggestions for dishes</li>
              <li>Tailor offers to boost revenue</li>
            </ul>
          </div>
        </div>
        <div class="d2-ai-form">
          <input
            type="text"
            class="d2-ai-input"
            [(ngModel)]="chatInput"
            [placeholder]="chatPlaceholder"
          />
          <button
            type="button"
            class="d2-btn-primary"
            (click)="startChat()"
            [disabled]="!canStartChat"
          >
            Start Chat
          </button>
        </div>
        <p class="d2-ai-foot mt-3">This will start a new conversation about a specific topic.</p>
        <p class="d2-ai-foot">
          Get insights on menus, orders, tables, devices, stations, hardware, delivery partners,
          staff, and reports.
          <br />
          Access previous conversations using the history icon below.
        </p>
        <p
          type="button"
          class="btn btn-link float-end p-0 pt-2 text-primary"
          (click)="getAllChats()"
        >
          <i class="bx bx-history"></i> Chat History
        </p>
      </section>
    </div>
  </div>

  <div class="d-flex pt-1 pb-3 gap-3">
    <div class="d2-sub-icon pl-3">
      <i class="bx bx-bar-chart-alt-2 font-weight-bold"></i>
    </div>
    <div class="d2-sub-title">SUMMARY</div>
  </div>

  <!-- Summary | Offers -->
  <div class="d2-row d2-row--bottom pt-2">
    <div class="d2-split-left">
      <section class="d2-card d2-summary">
        <div class="d2-card-head">
          <div class="d2-tabs">
            @for (tab of summaryTabs; track tab) {
              <button
                type="button"
                class="d2-tab"
                [class.d2-tab--active]="activeSummaryTab === tab"
                (click)="setSummaryTab(tab)"
              >
                {{ tab }}
              </button>
            }
          </div>
          <button type="button" class="d2-period-btn">
            <div class="dropdown">
              <button
                class="btn dropdown-toggle border rounded-5"
                type="button"
                id="dropdownMenuButton2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ displayChartSummaryPeriod }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                @for (period of chartSummaryPeriods; track period; let i = $index) {
                  <li (click)="onChangeChartSummaryPeriod(period)">
                    <a class="dropdown-item">{{ period.title }}</a>
                  </li>
                }
              </ul>
            </div>
          </button>
        </div>
        <div class="d2-tabs-wrap d-none">
          <div class="d2-tabs">
            @for (tab of summaryTabs; track tab) {
              <button
                type="button"
                class="d2-tab"
                [class.d2-tab--active]="activeSummaryTab === tab"
                (click)="setSummaryTab(tab)"
              >
                {{ tab }}
              </button>
            }
          </div>
        </div>
        <div class="d2-chart-container mt-5">
          <canvas
            baseChart
            [data]="barChartData"
            [options]="barChartOptions"
            type="bar"
            role="img"
            aria-label="Monthly summary chart"
          >
          </canvas>
        </div>
      </section>
    </div>
    <div class="d2-split-right d-none">
      <section class="d2-card d2-offers">
        <div class="d2-card-head">
          <div class="d2-card-title">
            <i class="bx bx-purchase-tag-alt"></i>
            <span>OFFERS</span>
          </div>
          <select class="d2-select" aria-label="Sort offers">
            <option>Closing soon first</option>
            <option>Newest</option>
          </select>
        </div>
        <div class="d2-offers-list">
          @for (o of visibleOffers; track o.title) {
            <article class="d2-offer">
              <img [src]="o.imageUrl" [alt]="o.title" width="72" height="72" />
              <div class="d2-offer-body">
                <h3 class="d2-offer-title">{{ o.title }}</h3>
                <p class="d2-offer-desc">{{ o.description }}</p>
                <p class="d2-offer-price">
                  <strong>{{ o.price }}</strong>
                  <del>{{ o.wasPrice }}</del>
                </p>
              </div>
              <span class="d2-offer-ribbon"
                ><span class="d2-offer-ribbon-text">{{ o.discount }}</span></span
              >
            </article>
          }
        </div>
        <div class="d2-dots" role="tablist" aria-label="Offer slides">
          @for (page of offerSlidePages; track page; let i = $index) {
            <button
              type="button"
              class="d2-dot"
              [class.d2-dot--on]="offerSlideIndex === i"
              (click)="setOfferSlide(i)"
              [attr.aria-label]="'Slide ' + (i + 1)"
            ></button>
          }
        </div>
      </section>
    </div>
  </div>

  <!-- Today's special (full width, footer) -->
  <section class="d2-card d2-special d-none">
    <div class="d2-card-head">
      <div class="d2-card-title">
        <i class="bx bx-time-five"></i>
        <span>TODAY'S SPECIAL</span>
      </div>
      <select class="d2-select" aria-label="Sort specials">
        <option>Relevance</option>
        <option>Price</option>
      </select>
    </div>
    <div class="d2-special-list">
      @for (sp of todaySpecials; track sp.name) {
        <div class="d2-special-item">
          <img [src]="sp.imageUrl" [alt]="sp.name" width="64" height="64" />
          <div class="d2-special-meta">
            <strong>{{ sp.name }}</strong>
            <span>{{ sp.note }}</span>
          </div>
          <span class="d2-special-price">{{ sp.price }}</span>
        </div>
      }
    </div>
  </section>

  <!-- Figma: AI chat side panel -->
  <div
    class="d2-chat-root"
    [class.d2-chat-root--open]="chatPanelOpen"
    [attr.aria-hidden]="!chatPanelOpen"
  >
    <div
      class="d2-chat-backdrop"
      role="presentation"
      tabindex="-1"
      (click)="closeChatPanel()"
    ></div>
    <aside
      class="d2-chat-panel"
      [class.d2-chat-panel--resizing]="chatPanelResizing"
      [style.width.px]="chatPanelWidth"
      role="dialog"
      aria-modal="true"
      aria-labelledby="d2-chat-panel-title"
      (click)="$event.stopPropagation()"
    >
      <div
        class="d2-chat-panel-resize"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize chat panel"
        (pointerdown)="onChatPanelResizeStart($event)"
      ></div>
      <header class="d2-chat-panel-head">
        <div class="d2-chat-panel-head-text">
          <h2 id="d2-chat-panel-title" class="d2-chat-panel-title">ForknFind AI Assistant</h2>
          @if (chatPanelName) {
            <p class="d2-chat-panel-name text-primary opacity-75">{{ chatPanelName }}</p>
          }
          @if (chatPanelSubtitle) {
            <p class="d2-chat-panel-sub">{{ chatPanelSubtitle }}</p>
          } @else {
            <p class="d2-chat-panel-sub">
              Ask about menus, offers, and sales for {{ restaurantName }}.
            </p>
          }
        </div>
        <div class="d2-chat-panel-head-actions">
          @if (chatOpenedFromHistory) {
            <!-- <button
              type="button"
              class="d2-chat-panel-back text-primary"
              (click)="backToChatHistory()"
            >
              Back to Chat History
            </button> -->
            <button
              type="button"
              class="d2-chat-panel-close text-primary bg-white border"
              (click)="backToChatHistory()"
              aria-label="Back to Chat History"
            >
              <i class="bx bx-history"></i>
            </button>
          }
          <button
            type="button"
            class="d2-chat-panel-close"
            (click)="closeChatPanel()"
            aria-label="Close chat"
          >
            <i class="bx bx-x"></i>
          </button>
        </div>
      </header>
      <div class="d2-chat-panel-accent"></div>
      <div class="d2-chat-panel-body">
        <app-chat-panel-messages
          [messages]="panelMessages"
          [hasMore]="hasMoreChatMessages"
          [loadingMore]="chatMessagesLoadingMore"
          [historyLoading]="chatHistoryLoading"
          (loadMore)="loadMoreChatMessages()"
        />
      </div>
      <footer class="d2-chat-panel-foot">
        <div class="d2-chat-panel-compose align-items-center">
          <textarea
            class="d2-chat-panel-input"
            rows="1"
            [(ngModel)]="panelComposer"
            (keydown)="onPanelComposerKeydown($event)"
            placeholder="Message…"
            aria-label="Message"
          ></textarea>
          <button
            type="button"
            class="d2-chat-panel-send"
            (click)="sendPanelMessage()"
            aria-label="Send"
          >
            <i class="bx bx-up-arrow-alt"></i>
          </button>
        </div>
        <!-- <p class="d2-chat-panel-hint">This chat is scoped to your restaurant. Connect an AI backend to enable live replies.</p> -->
      </footer>
    </aside>
  </div>

  <!-- Chat history side panel -->
  <div
    class="d2-chat-root"
    [class.d2-chat-root--open]="chatListPanelOpen"
    [attr.aria-hidden]="!chatListPanelOpen"
  >
    <div
      class="d2-chat-backdrop"
      role="presentation"
      tabindex="-1"
      (click)="closeChatListPanel()"
    ></div>
    <aside
      class="d2-chat-panel d2-chat-list-panel"
      [class.d2-chat-panel--resizing]="chatPanelResizing"
      [style.width.px]="chatPanelWidth"
      role="dialog"
      aria-modal="true"
      aria-labelledby="d2-chat-list-panel-title"
      (click)="$event.stopPropagation()"
    >
      <div
        class="d2-chat-panel-resize"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize chat history panel"
        (pointerdown)="onChatPanelResizeStart($event)"
      ></div>
      <header class="d2-chat-panel-head">
        <div class="d2-chat-panel-head-text">
          <h2 id="d2-chat-list-panel-title" class="d2-chat-panel-title">Chat History</h2>
          <p class="d2-chat-panel-sub">Previous conversations for {{ restaurantName }}.</p>
        </div>
        <button
          type="button"
          class="d2-chat-panel-close"
          (click)="closeChatListPanel()"
          aria-label="Close chat history"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>
      <div class="d2-chat-panel-accent"></div>
      <div class="d2-chat-panel-body d2-chat-list-body">
        <div class="d2-chat-list-scroll">
          @if (chatsLoading && !allChats.length) {
            <p class="d2-chat-history-loading">Loading chats…</p>
          } @else if (!chatsLoading && !allChats.length) {
            <p class="d2-chat-list-empty">No chats yet. Start a new conversation above.</p>
          } @else {
            <ul class="d2-chat-list" role="list">
              @for (chat of allChats; track trackChatListItem($index, chat)) {
                <li
                  class="d2-chat-list-item"
                  role="listitem"
                  [class.d2-chat-list-item--editing]="isEditingChatTitle(chat.chatId)"
                  [class.d2-chat-list-item--blocked]="
                    isChatTitleEditActive() && !isEditingChatTitle(chat.chatId)
                  "
                >
                  <div
                    class="d2-chat-list-open"
                    [attr.role]="
                      isChatTitleEditActive() && !isEditingChatTitle(chat.chatId)
                        ? null
                        : isEditingChatTitle(chat.chatId)
                          ? null
                          : 'button'
                    "
                    [attr.tabindex]="
                      isChatTitleEditActive() && !isEditingChatTitle(chat.chatId)
                        ? -1
                        : isEditingChatTitle(chat.chatId)
                          ? null
                          : 0
                    "
                    (click)="onChatListRowClick(chat, $event)"
                    (keydown.enter)="onChatListRowClick(chat, $event)"
                    [attr.aria-label]="
                      isEditingChatTitle(chat.chatId) ? null : 'Open ' + getChatListTitle(chat)
                    "
                    [matTooltip]="
                      isEditingChatTitle(chat.chatId) ? '' : getChatListDateTooltip(chat)
                    "
                    matTooltipPosition="above"
                    matTooltipClass="d2-chat-list-tooltip"
                  >
                    <span class="d2-chat-list-icon" aria-hidden="true">
                      <i class="bx bx-message-rounded-dots"></i>
                    </span>
                    <span class="d2-chat-list-copy">
                      @if (isEditingChatTitle(chat.chatId)) {
                        <input
                          #chatTitleInput
                          type="text"
                          class="d2-chat-list-title-input"
                          [(ngModel)]="editingChatTitleDraft"
                          [disabled]="renamingChatId === chat.chatId"
                          maxlength="120"
                          aria-label="Chat title"
                          (click)="$event.stopPropagation()"
                          (keydown)="onChatTitleInputKeydown(chat, $event)"
                          (blur)="onChatTitleInputBlur(chat)"
                        />
                      } @else {
                        <span class="d2-chat-list-title">{{ getChatListTitle(chat) }}</span>
                      }
                      <span class="d2-chat-list-date">{{
                        formatChatListRelativeDate(chat.updatedAt)
                      }}</span>
                    </span>
                  </div>
                  <div class="d2-chat-list-actions">
                    <button
                      type="button"
                      class="d2-chat-list-menu-trigger"
                      [class.d2-chat-list-menu-trigger--active]="isChatListMenuOpen(chat.chatId)"
                      [disabled]="isChatTitleEditActive()"
                      (click)="toggleChatListMenu(chat, $event)"
                      [attr.aria-expanded]="isChatListMenuOpen(chat.chatId)"
                      aria-haspopup="menu"
                      [attr.aria-label]="'Actions for ' + getChatListTitle(chat)"
                    >
                      <i class="bx bx-dots-vertical-rounded" aria-hidden="true"></i>
                    </button>
                    @if (isChatListMenuOpen(chat.chatId)) {
                      <div class="d2-chat-list-menu" role="menu" (click)="$event.stopPropagation()">
                        <button
                          type="button"
                          class="d2-chat-list-menu-item"
                          role="menuitem"
                          (click)="onChatMenuViewMessages(chat, $event)"
                        >
                          <i class="bx bx-chat" aria-hidden="true"></i>
                          <span>View messages</span>
                        </button>
                        <button
                          type="button"
                          class="d2-chat-list-menu-item"
                          role="menuitem"
                          (click)="onChatMenuRename(chat, $event)"
                          [disabled]="
                            renamingChatId === chat.chatId || isEditingChatTitle(chat.chatId)
                          "
                        >
                          <i class="bx bx-pencil" aria-hidden="true"></i>
                          <span>Rename</span>
                        </button>
                        <div class="d2-chat-list-menu-separator" role="separator"></div>
                        <button
                          type="button"
                          class="d2-chat-list-menu-item d2-chat-list-menu-item--danger"
                          role="menuitem"
                          (click)="onChatMenuDeleteChat(chat, $event)"
                          [disabled]="isDeletingChat(chat.chatId)"
                        >
                          <i class="bx bx-trash" aria-hidden="true"></i>
                          <span>Delete chat</span>
                        </button>
                      </div>
                    }
                  </div>
                </li>
              }
            </ul>
            @if (hasMoreChats) {
              <div class="d2-chat-load-more-wrap">
                <button
                  type="button"
                  class="d2-chat-load-more"
                  (click)="loadMoreChats()"
                  [disabled]="chatsLoadingMore || isChatTitleEditActive()"
                >
                  @if (chatsLoadingMore) {
                    Loading more…
                  } @else {
                    Load more chats
                  }
                </button>
              </div>
            }
          }
        </div>
      </div>
    </aside>
  </div>
</div>
